var currentDownload;

function updateQueryString(key, value, url) {
  if (!url) url = window.location.href;
  var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
    hash;

  if (re.test(url)) {
    if (typeof value !== "undefined" && value !== null)
      return url.replace(re, "$1" + key + "=" + value + "$2$3");
    else {
      hash = url.split("#");
      url = hash[0].replace(re, "$1$3").replace(/(&|\?)$/, "");
      if (typeof hash[1] !== "undefined" && hash[1] !== null)
        url += "#" + hash[1];
      return url;
    }
  } else {
    if (typeof value !== "undefined" && value !== null) {
      var separator = url.indexOf("?") !== -1 ? "&" : "?";
      hash = url.split("#");
      url = hash[0] + separator + key + "=" + value;
      if (typeof hash[1] !== "undefined" && hash[1] !== null)
        url += "#" + hash[1];
      return url;
    } else return url;
  }
}

function tdproduct(val) {
  return product_map2.hasOwnProperty(val) ? product_map2[val].label : val;
}

function showDownloadOptions(data, status, xhr) {
  data = JSON.parse(data);
  // console.log("DATA RESPONSE:", data.wares[0].notes)
  if (data.err) {
    $("#product").empty();
    $("<option/>", {
      html: "ERROR",
    }).appendTo($("#product"));
    $("#familyContainer").hide();
    // $("#showOldCheck").hide();
  } else {
    if (data.products) {
      $("#product").empty();
      var items = [
        "<option value='' disabled selected>Select your Teradek Product</option>",
      ];
      var sortedProducts = data.products.sort(function (a, b) {
        var displayA = tdproduct(a).toLowerCase();
        var displayB = tdproduct(b).toLowerCase();
        return displayA < displayB ? -1 : displayA > displayB ? 1 : 0;
      });
      $.each(sortedProducts, function (i, val) {
        var hash =
          val in product_map2 && "hash" in product_map2[val]
            ? product_map2[val].hash
            : val.toLowerCase();
        items.push(
          '<option data-hash="' +
            hash +
            '" value="' +
            val +
            '">' +
            tdproduct(val) +
            "</option>"
        );
      });

      $("#product").html(items.join(""));
      $('#product option[value="paralinx"]').remove();

      $("#familyContainer").hide();
    } else if (data.families) {
      $("#family").empty();
      var items = [],
        fam = data.families[data.families.length - 1];
      $.each(data.families, function (i, val) {
        items.push(
          '<option value="' + val + '">' + tdproduct(val) + "</option>"
        );
      });
      $("#family").html(items.join(""));
      $("#familyContainer").show();
      $("#family").val(fam);
      $.ajax(
        "https://update.teradek.com/wares.php?product=" +
          $("#product").val() +
          "&family=" +
          fam,
        {
          success: showDownloadOptions,
          showPrevButton,
        }
      );
    } else if (data.wares && data.wares.length) {
      console.log("here first");
      console.log("here second");
      console.log("length: ", data.wares.length);
      console.log("data: ", data.wares);
      var items = [];
      var outer = $("<div/>", {
          class: "downloadTable",
        }).appendTo($("#downloadsPage")),
        t = $("<div/>");
      t.appendTo(outer);
      var item = "<div>";
      var hiddenItem;
      $.each(data.wares[0], function (key, val) {
        switch (key) {
          case "product":
            item +=
              '<!--h1 class="cs-txt cs-product-title cs-black">' +
              tdproduct(val) +
              "</h1-->";
            break;
          default:
        }
      });
      // START OF UPDATE

      var apps = [];
      var videos = [];
      var guides = [];
      var codecs = [];
      var firmware = [];
      var sectionTitle;
      $.each(data.wares, function (key, val) {
        data.wares[key].id = key;
        // console.log(console.log('WARES', data.wares))

        if (!val.filename.match("teradek.com") || val.filename.match(".pdf")) {
          val.additional_attr = 'target="_new"';
        }

        if (val.filename != "") {
          val.filename = val.filename.replace("http://", "https://");
          //download file using https
          val.filename = updateQueryString("protocol", "https", val.filename);
        }

        if (
          val.part == "app" ||
          val.part == "app2" ||
          val.part == "update tool" ||
          val.part == "monitor"
        ) {
          apps.push(data.wares[key]);
          //  console.log("This is the apps array: ", apps);
        }
        if (val.part == "videos") {
          videos.push(data.wares[key]);
          //  console.log("This is the videos array: ", videos);
        }
        if (
          val.part == "qsguide" ||
          val.part == "qsguide2" ||
          val.part == "qsguide3" ||
          val.part == "refguide" ||
          val.part == "refguide2" ||
          val.part == "manual" ||
          val.part == "specs"
        ) {
          guides.push(data.wares[key]);
          //  console.log("This is the guides array: ", guides);
        }
        if (
          val.part == "ctrl5" ||
          val.part == "codec" ||
          val.part == "codec2" ||
          val.part == "firmware" ||
          val.part == "firmware_shd" ||
          val.part == "firmware-shd" ||
          val.part == "firmware-bolt" ||
          val.part == "dual" ||
          val.part == "plugin" ||
          val.part == "coproc" ||
          val.part == "fpga" ||
          val.part == "recovery" ||
          val.part == "controller" ||
          val.part == "manager" ||
          val.part == "monitor"
        ) {
          codecs.push(data.wares[key]);
          console.log("This is the codecs array: ", codecs);
        }
        // if (val.part == "firmware") {
        //   firmware.push(data.wares[key]);
        //   //  console.log("This is the codecs array: ", codecs);
        // }
      });

      // console.log("FIRMWARE ", codecs)
      sortByDate(codecs);
      // console.log("FIRMWARE ARRAY AFTER", codecs)
      // addCodecs, addApps, addGuides, addVideos
      var renderOrder = [addCodecs, addApps, addGuides, addVideos];
      //CHECK the CHECKBOX
      let prevVersionShowing = $("#showOldCheck").is(":checked");

      if (prevVersionShowing) {
        var prevVersionHtml = `<i class="fa-solid fa-minus pe-2"></i><span class="">Hide Previous Versions</span>`;
      } else {
        var prevVersionHtml = `<i class="fa-solid fa-plus pe-2"></i><span class="">Show Previous Versions</span>`;
      }
      //END CHECK the CHECKBOX
      $.each(renderOrder, function (key, val) {
        renderOrder[key]();
      });

      function sortByDate(list) {
        list.sort((a, b) => (a.pubdate > b.pubdate ? -1 : 1));
        // console.log("MY NEW LIST:", list)
      }

      function addApps() {
        // APPS
        if (apps.length > 0) {
          item += `<div data-wrapper = "apps" class="section-wrapper mb-12">`;
          item += `<div class="d-flex align-items-end justify-content-between mb-2">`;
          item += `
          <div class="d-flex align-items-baseline ">`;
          item += `<i class="fa-light fa-browser fa-2xl me-4 text-gray-3"></i>`;
          item += `<h2 class="fs-1 text-gray-3"> Apps </h2>`;
          item += `</div>`;
          item += `<a class=" cs-btn-prev  showOldBtn has-btn-prev-version text-gray-3 fs-6 d-inline-block" style="cursor:pointer;">${prevVersionHtml}</a>`;

          item += `</div>`;

          item += `<hr class="cs-heading-hr pb-4"/>`;
          item += ` <div class="ps-0 ps-md-8 pb-0"\>`;

          $.each(apps, function (key, val) {
            //
            item += `<div class="cs-light-bottom-border">`;
            item += `<a data-type="app" href="${val.filename}" style="display:block;" target ="_blank" class="pt-8 text-decoration-none">`;
            /// START ROW
            item += `<div class="px-0 align-items-start align-items-md-start d-flex flex-column flex-md-row">`;
            //
            item += `<div class="col-md-6 d-flex align-items-center px-0">`;
            item += `<div class="d-flex flex-column">`;
            //
            if (
              val.platform == "iOS" ||
              val.platform == "ios" ||
              val.platform == "Mac OS" ||
              val.platform == "Mac OSX" ||
              val.platform == "mac OSX"
            ) {
              item += `<i class="d-inline-block fa-brands fa-apple fa-xl text-gray-3 mb-6"></i>`;
            } else if (val.platform == "Android" || val.platform == "android") {
              item += `<i class="d-inline-block fa-brands fa-android fa-xl text-gray-3 mb-6"></i>`;
            } else if (val.platform == "Windows" || val.platform == "windows") {
              item += `<i class="d-inline-block fa-brands fa-windows fa-xl text-gray-3 mb-6"></i>`;
            } else {
              item += ``;
            }

            item += `<h4 class="text-gray-9 fs-4 fw-500 mb-0"> ${val.title} ${
              val.version
                ? `<span class="text-blue-3">v${val.version}</span>`
                : ``
            }</h4>`;
            if (val.pubdate && val.pubdate !== "0000-00-00") {
              item += `<div class=" mb-md-4 mb-6"><span class="text-gray-3 fw-700 text-decoration-none fs-7"> ${val.pubdate} </span></div>`;
            }

            item += "</div>";
            item += `</div>`;

            //show this button on desktop
            item += `<div class="col-md-6 px-0 justify-content-end align-items-center d-md-flex d-none">`;
            item += `<div class="btn btn-black align-items-center px-4 py-2 lh-1 mb-6 mb-md-0" style="border-radius:16px;"><i class="text-white fa-regular fa-arrow-down-to-line pe-2"></i><span class="text-white fw-700 fs-8 ls-px-12">DOWNLOAD</span></div>`;
            item += `</div>`;
            //
            item += `</div>`;
            ///END ROW
            // if (val.pubdate && val.pubdate !== "0000-00-00") {
            //   item += `<div class=" mb-md-4 mb-6"><span class="text-gray-3 fw-700 text-decoration-none fs-7"> ${val.pubdate} </span></div>`;
            // }

            if (val.inotes) {
              //START ROW
              item += `<div class="row">`;
              item += `<div class="col-md-6">`;
              item += `<div class=" mb-md-4 mb-6"><span class="text-gray-4 fw-400 text-decoration-none fs-5">${val.inotes} </span></div>`;
              item += "</div>";
              //ENDROW
              item += "</div>";
            }

            item += `</a>`;

            //show this button on mobile
            //
            item += `<div class="col-md-6 d-flex px-0 justify-content- align-items-center d-md-none d-block">`;
            item += `<div class="btn btn-black align-items-center px-4 py-2 lh-1 mb-6 mb-md-0" style="border-radius:16px;"><i class="text-white fa-regular fa-arrow-down-to-line pe-2"></i><span class="text-white fw-700 fs-8 ls-px-12">DOWNLOAD</span></div>`;
            item += `</div>`;
            //
            checkValNotes(val);
            item += "</div>";
          });

          item += "</div>";

          item += "</div>";
        }
      }

      function checkValNotes(val) {
        if (val.notes) {
          var product = val.product ? "product=" + val.product : "";
          var part = val.part ? "&part=" + val.part : "";
          var family = val.family ? "&family=" + val.family : "";
          var q = product + "&" + part + "&" + family;
          item +=
            '<div class="show-release-notes text-gray-3 fs-7 text-decoration-underline cursor-pointer fw-700 pt-2 pb-4">Show Release Notes</div><div style="display:none;">' +
            '<div class="cs-notes-wrapper">' +
            marked(val.notes) +
            '<a href="https://update.teradek.com/release_notes.html?' +
            q +
            '" class="show_full_release_notes text-gray-3 mb-2">Full Release Notes History...</a>';
          if (val.license) {
            item += '<div class="license">' + val.license + "</div>";
          }
          item += "</div>";
          item += "</div>";
          // item += `<span class="cs-txt cs-cool-gray cs-item-notes"> ${marked(val.notes)} </span>`;
        }
      }

      function checkValNotesOrPrevious(val) {
        if (val.notes) {
          var product = val.product ? "product=" + val.product : "";
          var part = val.part ? "&part=" + val.part : "";
          var family = val.family ? "&family=" + val.family : "";
          var q = product + "&" + part + "&" + family;
          item +=
            '<div class="show-release-notes text-gray-3 fs-7 text-decoration-underline cursor-pointer fw-700 pt-4 pb-6">Show Release Notes</div><div style="display:none;">' +
            '<div class="cs-notes-wrapper">' +
            marked(val.notes) +
            '<a href="https://update.teradek.com/release_notes.html?' +
            q +
            '" class="show_full_release_notes text-gray-3 mb-2">Full Release Notes History...</a>';
          if (val.license) {
            item += '<div class="license">' + val.license + "</div>";
          }
          item += "</div>";
          item += "</div>";
          // item += `<span class="cs-txt cs-cool-gray cs-item-notes"> ${marked(val.notes)} </span>`;
        }
      }

      function addVideos() {
        // VIDEOS
        if (videos.length > 0) {
          item += `<div data-wrapper = "videos" class="section-wrapper mb-2">`;
          item += `<div class="d-flex align-items-baseline">`;
          item += `<i class="fa-light fa-circle-play fa-2xl me-4 text-gray-3"></i>`;
          item += `<h2 class="fs-1 text-gray-3"> Videos </h2>`;
          item += `</div>`;

          item += `</div>`;

          item += `<hr class="cs-heading-hr pb-4"/>`;
          item += ` <div class="ps-0 ps-md-8 pb-14">`;

          //
          $.each(videos, function (key, val) {
            switch (val.part) {
              case "videos":
                item += `<div class="cs-light-bottom-border">`;
                item += `<a data-type = "video" class="pt-4 text-decoration-none popup-video" href="${val.filename}" style="display:block;" >`;
                ///START ROW
                item += `<div class="px-0 align-items-start align-items-md-start d-flex flex-column flex-md-row">`;
                //
                break;
              default:
            }

            item += `<div class=" col-md-6 px-0">`;
            item += `<div class="d-flex flex-column">`;
            item += `<h4 class="text-gray-9 fs-4 fw-500 mb-0"> ${val.title} ${
              val.version
                ? `<span class="text-blue-3">v${val.version}</span>`
                : ``
            }</h4>`;
            if (val.pubdate && val.pubdate !== "0000-00-00") {
              item += `<div class=" mb-md-4 mb-6"><span class="text-gray-3 fw-700 text-decoration-none fs-7"> ${val.pubdate} </span></div>`;
            }
            item += `</div>`;
            item += "</div>";
            //show this button on desktop
            //
            item += `<div class="col-md-6 px-0 justify-content-end align-items-center d-md-flex d-none">`;
            item += `<div class="btn btn-black align-items-center px-4 py-2 lh-1 mb-6 mb-md-0" style="border-radius:16px;"><i class="text-white fa-regular fa-arrow-up-right-from-square pe-2"></i><span class="text-white fw-700 fs-8 ls-px-12">WATCH THE VIDEO</span></div>`;
            item += `</div>`;
            //
            item += `</div>`;
            ///END ROW
            // if (val.pubdate && val.pubdate !== "0000-00-00") {
            //   item += `<div class=" mb-md-4 mb-6"><span class="text-gray-3 fw-700 text-decoration-none fs-7"> ${val.pubdate} </span></div>`;
            // }

            if (val.inotes) {
              //START ROW
              item += `<div class="row">`;
              item += `<div class="col-md-6">`;
              item += `<div class=" mb-md-4 mb-6"><span class="text-gray-4 fw-400 text-decoration-none fs-5">${val.inotes} </span></div>`;
              item += "</div>";
              //ENDROW
              item += "</div>";
            }

            item += "</div>";
            checkValNotes(val);
            item += `</a>`;

            //show this button on mobile
            //
            item += `<div class="col-md-6 d-flex px-0 justify-content-start align-items-center d-md-none d-block">`;
            item += `<div class="btn btn-black align-items-center px-4 py-2 lh-1 mb-6 mb-md-0" style="border-radius:16px;"><i class="text-white fa-regular fa-arrow-up-right-from-square pe-2"></i><span class="text-white fw-700 fs-8 ls-px-12">WATCH THE VIDEO</span></div>`;
            item += `</div>`;
            //

            item += "</div>";
            item += "</div>";
          });
        }
      }

      function addGuides() {
        // GUIDES
        if (guides.length > 0) {
          item += `<div data-wrapper = "guides" class="section-wrapper mb-12">`;
          item += `<div class="d-flex align-items-end justify-content-between mb-2">`;
          item += `<div class="d-flex align-items-baseline">`;
          item += `<i class="fa-light fa-file-lines fa-2xl me-4 text-gray-3"></i>`;
          item += `<h2 class="fs-1 text-gray-3">Guides</h2>`;
          item += `</div>`;
          item += `<a class=" cs-btn-prev  showOldBtn has-btn-prev-version text-gray-3 fs-6 d-inline-block" style="cursor:pointer;">${prevVersionHtml}</a>`;

          item += `</div>`;

          item += `<hr class="cs-heading-hr pb-4"/>`;
          item += ` <div class="ps-0 ps-md-8 pb-0"\>`;

          //
          $.each(guides, function (key, val) {
            //
            item += `<div class="cs-light-bottom-border">`;
            item += `<a data-type="guide" href="${val.filename}" style="display:block;" target ="_blank" class="pt-4 text-decoration-none">`;
            ///START ROW
            item += `<div class="px-0 align-items-start align-items-md-start d-flex flex-column flex-md-row">`;
            //
            item += `<div class="col-md-6 d-flex align-items-center px-0">`;
            item += `<div class="d-flex flex-column">`;
            //
            item += `<h4 class="text-gray-9 fs-4 fw-500 mb-0"> ${val.title} ${
              val.version
                ? `<span class="text-blue-3">v${val.version}</span>`
                : ``
            }</h4>`;
            if (val.pubdate && val.pubdate !== "0000-00-00") {
              item += `<div class=" mb-md-4 mb-6"><span class="text-gray-3 fw-700 text-decoration-none fs-7"> ${val.pubdate} </span></div>`;
            }
            item += `</div>`;
            item += "</div>";
            //show this button on desktop
            //
            item += `<div class="col-md-6 px-0 justify-content-end align-items-center d-md-flex d-none">`;
            item += `<div class="btn btn-black align-items-center px-4 py-2 lh-1" style="border-radius:16px;"><i class="text-white fa-regular fa-arrow-up-right-from-square pe-2"></i><span class="text-white fw-700 fs-8 ls-px-12">READ THE GUIDE</span></div>`;
            item += `</div>`;
            //
            item += `</div>`;
            ///END ROW
            // if (val.pubdate && val.pubdate !== "0000-00-00") {
            //   item += `<div class=" mb-md-4 mb-6"><span class="text-gray-3 fw-700 text-decoration-none fs-7">${val.pubdate} </span></div>`;
            // }

            if (val.inotes) {
              //START ROW
              item += `<div class="row">`;
              item += `<div class="col-md-6">`;
              item += `<div class=" mb-md-4 mb-6"><span class="text-gray-4 fw-400 text-decoration-none fs-5">${val.inotes} </span></div>`;
              item += "</div>";
              //ENDROW
              item += "</div>";
            }

            item += `</a>`;

            //show this button on mobile
            //
            item += `<div class="col-md-6 d-flex px-0 justify-content-start align-items-center d-md-none d-block">`;
            item += `<div class="btn btn-black align-items-center px-4 py-2 lh-1 mb-6 mb-md-0" style="border-radius:16px;"><i class="text-white fa-regular fa-arrow-up-right-from-square pe-2"></i><span class="text-white fw-700 fs-8 ls-px-12">READ THE GUIDE</span></div>`;
            item += `</div>`;
            //

            checkValNotes(val);
            item += `</div>`;
          });

          item += `</div>`;

          item += '<div class="cs-prev-wrapper"/>';
          item += "</div>";

          item += `</div>`;
        }
      }

      function addCodecs() {
        // CODECS
        if (codecs.length > 0) {
          item += `<div data-wrapper = "codecs" class="section-wrapper mb-12">`;
          item += `<div class="d-flex align-items-end justify-content-between mb-2">`;
          item += `<div class="d-flex align-items-baseline">`;
          item += `<i class="fa-light fa-arrows-rotate fa-2xl me-4 text-gray-3"></i>`;
          item += `<h2 class="fs-1 text-gray-3"> Firmware</h2>`;
          item += `</div>`;
          item += `<a class=" cs-btn-prev  showOldBtn has-btn-prev-version text-gray-3 fs-6 d-inline-block" style="cursor:pointer;">${prevVersionHtml}</a>`;

          item += `</div>`;

          item += `<hr class="cs-heading-hr pb-4"/>`;
          item += ` <div class="ps-0 ps-md-8 pb-14">`;

          //
          $.each(codecs, function (key, val) {
            // if (Number(key) < 1) {
            // alert(key);
            //
            item += `<div class="cs-light-bottom-border">`;
            item += `<a href="${val.filename}" data-type="codec" style="display:block;" class="pt-4 text-decoration-none">`;
            ///START ROW
            item += `<div class="px-0 align-items-start align-items-md-start d-flex flex-column flex-md-row">`;
            //
            item += `<div class="col-md-6 d-flex align-items-center px-0">`;
            item += `<div class="d-flex flex-column">`;
            item += `<h4 class="text-gray-9 fs-4 fw-500 mb-0"> ${val.title} ${
              val.version
                ? `<span class="text-blue-3">v${val.version}</span>`
                : ``
            }</h4>`;
            if (val.pubdate && val.pubdate !== "0000-00-00") {
              item += `<div class=" mb-md-4 mb-6"><span class="text-gray-3 fw-700 text-decoration-none fs-7"> ${val.pubdate} </span></div>`;
            }
            item += `</div>`;
            item += "</div>";

            //show this button on desktop
            //
            item += `<div class="col-md-6 px-0 justify-content-end align-items-center d-md-flex d-none">`;
            item += `<div class="btn btn-black align-items-center px-4 py-2 lh-1" style="border-radius:16px;"><i class="text-white fa-regular fa-arrow-down-to-line pe-2"></i><span class="text-white fw-700 fs-8 ls-px-12">DOWNLOAD</span></div>`;
            item += `</div>`;
            //
            item += `</div>`;
            ///END ROW
            // if (val.pubdate && val.pubdate !== "0000-00-00") {
            //   item += `<div class=" mb-md-4 mb-6"><span class="text-gray-3 fw-700 text-decoration-none fs-7"> ${val.pubdate} </span></div>`;
            // }
            item += `</a>`;
            if (val.inotes) {
              //START ROW
              item += `<div class="row">`;
              item += `<div class="col-md-6">`;
              item += `<div class=" mb-md-4 mb-6"><span class="text-gray-4 fw-400 text-decoration-none fs-5">${val.inotes} </span></div>`;
              item += "</div>";
              //ENDROW
              item += "</div>";
            }

            //show this button on mobile
            //
            item += `<div class="col-md-6 d-flex px-0 justify-content-start align-items-center d-md-none d-block">`;
            item += `<div class="btn btn-black align-items-center px-4 py-2 lh-1 mb-6" style="border-radius:16px;"><i class="text-white fa-regular fa-arrow-down-to-line pe-2"></i><span class="text-white fw-700 fs-8 ls-px-12">DOWNLOAD</span></div>`;
            item += `</div>`;
            //
            checkValNotes(val);
            // checkValNotesOrPrevious(val);
            item += `</div>`;
            // } else {
            // checkValNotes(val);
            // checkValNotesOrPrevious(val);
            // putIntoPreviousWrapper(val);
            // }
            // }
          });

          //

          item += `</div>`;

          item += '<div class="cs-prev-wrapper">';
          item += "</div>";

          item += `</div>`;
        }
      }

      function putIntoPreviousWrapper(val) {
        if (val.pubdate && val.pubdate !== "0000-00-00") {
          hiddenItem += `<hr/>`;
          hiddenItem += `<div class=" mb-4"><span class="text-gray-3 fw-700 text-decoration-none fs-7 ls-px-12"> ${val.pubdate} </span></div>`;
        }

        hiddenItem += `<a data-type="codec" href="${val.filename}" style="display:block;" target ="_blank" class="cs-item-link cs-cool-gray no link">`;
        hiddenItem += `<div class="cs-item-grid">`;
        hiddenItem += `<img class="cs-grid-label-icon" src="https://update.teradek.com/getting-started/icons/Icon-Update.svg"/>`;
        hiddenItem += `<div class="bg-black d-flex align-items-center px-4 py-2" style="border-radius:16px;"><i class="text-white fa-regular fa-arrow-down-to-line pe-2"></i><span class="text-white fw-700 fs-8 ls-px-12">DOWNLOAD</span></div>`;
        hiddenItem += `<h4 class="cs-txt cs-cool-gray cs-item-title"> ${
          val.title
        } ${
          val.version ? `<span class="text-blue-3">v${val.version}</span>` : ``
        }</h4>`;
        hiddenItem += "</div>";
        hiddenItem += `</a>`;
        if (val.notes) {
          var product = val.product ? "product=" + val.product : "";
          var part = val.part ? "&part=" + val.part : "";
          var family = val.family ? "&family=" + val.family : "";
          var q = product + "&" + part + "&" + family;
          hiddenItem +=
            '<div class="show-release-notes text-gray-3 fs-7 text-decoration-underline fw-700 pt-2 pb-4">Show Release Notes</div><div style="display:none;">' +
            '<div class="cs-notes-wrapper">' +
            marked(val.notes) +
            "</div>" +
            '<a href="release_notes.html?' +
            q +
            '" class="show_full_release_notes text-gray-6 mb-6">Full Release Notes History...</a>';
          if (val.license) {
            hiddenItem += '<div class="license">' + val.license + "</div>";
          }
          hiddenItem += "</div>";
          // item += `<span class="cs-txt cs-cool-gray cs-item-notes"> ${marked(val.notes)} </span>`;
        }
        console.log("Trying to put this in the other spot");
      }

      // END OF UPDATE

      $("<div>")
        .html(item + "</div>")
        .appendTo(t);

      $(hiddenItem).appendTo(".cs-prev-wrapper");

      if (codecs.length > 1) {
        $(".cs-btn-prev").show();
      } else {
        $(".cs-btn-prev").hide();
      }

      $(".cs-prev-wrapper").hide();

      $.each(data.wares, function (key, file) {
        var item =
          '<div class="' + (items.length % 2 ? "groupEven" : "groupOdd") + '">';

        items.push(item + "</div>");
      });

      $(".show-release-notes").on("click", function (e) {
        if ($(this).next().is(":hidden")) {
          $(this).html("Hide Release Notes");
          $(this).next().fadeToggle(500);
        } else {
          $(this).html("Show Release Notes");
          $(this).next().fadeToggle(500);
        }
        setHeight();
      });
      // $('#downloadsPage').show();
      // $('.downloadTable').show();
      // $('#showOldBtn').show();
      // makeLinksOpenOutsideFrame();
      setHeight();
      // mergeDuplicateInfoColumns();
      // showBoltImage();
    }
  }
  // $('<div class="cs-footer-spacing"></div><div/>').appendTo(t);
  // $('<div class="cs-footer-spacing"></div><div/>').html(items.join('')).appendTo(t);
}

function makeLinksOpenOutsideFrame() {
  $(".downloadTable a").attr("target", "_blank").attr("rel", "noopener");
}

function showBoltImage() {
  $(".boltHelperImage").remove();
  if ($("#family").is(":visible")) {
    if ($("#family").val() == "1stgen") {
      $("#family").after(
        '<div class="boltHelperImage"><img  style="height: 139px;" src="//cdn.shopify.com/s/files/1/0095/4332/files/first-gen-bolts.png?4703"></div>'
      );
    } else {
      $("#family").after(
        '<div class="boltHelperImage"><img src="//cdn.shopify.com/s/files/1/0095/4332/files/second-gen-bolt.png?4703" style="height:139px"></div>'
      );
    }
  }
}

function mergeDuplicateInfoColumns() {
  var notes = $(".notes");
  var $prev = null;
  $.each(notes, function (k, v) {
    $prev = $prev == null && k != 0 ? $(notes[k - 1]) : $prev;
    var $cur = $(v);
    if ($prev && $prev.text() == $cur.text()) {
      var rowSpan = $prev.attr("rowspan");
      rowSpan = rowSpan ? ++rowSpan : 2;
      $prev.attr("rowspan", rowSpan);
      $cur.remove();
    } else {
      $prev = null;
    }
  });
}

function getUrlVars() {
  var vars = {};
  var parts = document.location.href.replace(
    /[?&]+([^=&]+)=([^&]*)/gi,
    function (m, key, value) {
      vars[key] = value;
    }
  );
  return vars;
}

var vars = getUrlVars();
var parent_url = vars["parent"];

function setHeight() {
  console.log("setHeight", $("#downloads-page-container").height() + 50);
  // $.postMessage(
  //   {
  //     if_height: $("#downloads-page-container").height() + 50,
  //   },
  //   parent_url,
  //   parent
  // );
}

// $(document).ready(function () {

// $('.popup-video').click(function() {
//     console.log('magnific has bee clicked')
//   })

//   if ('tableonly' in vars) {
//     $('body').addClass('tableonly');
//   }
//   $.ajax(
//     'wares.php',
//     {
//       contentType: "application/json",
//       success: showDownloadOptions,
//       dataType: "json"

//     }
//   ).done(function () {
//     var hash = window.location.hash.substring(1).replace(/\+/g, ' ');
//     if (hash.search(/^vidiu$/) != -1) {
//       hash = 'vudu';
//     }
//     $('#product').val(hash).change();
//     $('.show_full_release_notes').colorbox({
//       iframe: true,
//       width: '80%',
//       height: '80%',
//     });
//   });

jQuery(document).ready(function ($) {
  if ("tableonly" in vars) {
    $("body").addClass("tableonly");
  }
  $.ajax("https://update.teradek.com/wares.php", {
    success: showDownloadOptions,
  }).done(function () {
    var hash = window.location.hash.substring(1).replace(/\+/g, " ");
    if (hash.search(/^vidiu$/) != -1) {
      hash = "vudu";
    }
    var selectedProduct = $("#product option[data-hash=" + hash + "]").val();
    $("#product").val(selectedProduct).change();

    $(".show_full_release_notes").colorbox({
      iframe: true,
      width: "80%",
      height: "80%",
    });
  });

  $("#product").change(function () {
    $("#family").empty().val("");
    $("#familyContainer").hide();
    $("#showOldCheck").prop("checked", false);
    // $(".showOldBtn").html(
    //   '<i class="fa-solid fa-plus pe-2"></i><span class="">Show Previous Versions</span>'
    // );
    $("#downloadsPage").empty();

    if ($(this).val()) {
      var new_hash = $(this).find(":selected").data("hash");
      window.location.hash = new_hash;
      // $.postMessage({ hash: new_hash }, parent_url, parent);

      $.ajax("https://update.teradek.com/wares.php?product=" + $(this).val(), {
        success: showDownloadOptions,
      });
    } else {
      // $(".showOldBtn").hide();
    }
  });

  $("#family").change(function () {
    $("#showOldCheck").prop("checked", false);
    $(".showOldBtn").html(
      '<i class="fa-solid fa-plus pe-2"></i><span class="">Show Previous Versions</span>'
    );
    $("#downloadsPage").empty();
    if ($(this).val()) {
      $.ajax(
        "https://update.teradek.com/wares.php?product=" +
          escape($("#product").val()) +
          "&family=" +
          $(this).val(),
        {
          success: showDownloadOptions,
        }
      );
    }
  });

  // let isChecked = false;

  // function togglePrevData(isChecked) {
  //   $("#downloadsPage").empty();
  //   console.log("loading again....");

  //   if ($("#product").val() !== "") {
  //     $.ajax(
  //       "https://update.teradek.com/wares.php?product=" +
  //         $("#product").val() +
  //         ($("#family").val() ? "&family=" + $("#family").val() : "") +
  //         "&showold=" +
  //         isChecked,
  //       {
  //         success: showDownloadOptions,
  //       }
  //     );
  //   }
  // }

  // $(".show-prev").click(function () {
  //   isChecked = !isChecked;
  //   togglePrevData(isChecked);
  //   if (isChecked) {
  //     $(this).html(
  //       '<i class="fa-solid fa-minus pe-2"></i><span class="">Hide Previous Versions</span>'
  //     );
  //   } else {
  //     $(this).html(
  //       '<i class="fa-solid fa-plus pe-2"></i><span class="">Show Previous Versions</span>'
  //     );
  //   }
  //   // $(".cs-prev-wrapper").toggle();
  // });

  $(document).on("change", "#showOldCheck", function () {
    $("#downloadsPage").empty();
    if ($("#product").val() !== "") {
      $.ajax(
        "https://update.teradek.com/wares.php?product=" +
          $("#product").val() +
          ($("#family").val() ? "&family=" + $("#family").val() : "") +
          "&showold=" +
          $(this).prop("checked"),
        {
          success: showDownloadOptions,
        }
      );
    }
  });

  $(document).on("click", ".showOldBtn", function () {
    console.log("clicked show old button");

    console.log($("#showOldCheck").value);

    if ($("#showOldCheck").is(":checked")) {
      $(".showOldBtn").html(
        '<i class="fa-solid fa-minus pe-2"></i><span class="">Hide Previous Versions</span>'
      );
    } else {
      $(".showOldBtn").html(
        '<i class="fa-solid fa-plus pe-2"></i><span class="">Show Previous Versions</span>'
      );
    }

    $("#showOldCheck").click();
  });
});

function launchPopup(f) {
  var modal = document.getElementById("modalContainer");
  modal.style.display = "flex";
  console.log("open popup");
  currentDownload = f;
  var str = currentDownload.toString();
  var newstr = str.replace(
    `http://update.teradek.com/download.php?file=/Teradek`,
    "https://update.teradek.com/download.php?file=https://cdn.teradek.com/Public"
  );

  console.log("After to string: ", str);
  console.log(currentDownload);
  console.log("After replace", newstr);
  $("#contactForm").attr(
    "action",
    `https://go.cs.inc/l/923653/2022-02-03/l8dcc/?success_location=https://www.teradek.com/pages/download_success?download_file=${newstr}`
  );
  console.log(window.location);
  console.log("original value", f);
  // console.log("action set to", $("#contactForm").attr("action"));
}

function closeModal(e) {
  var modal = document.getElementById("modalContainer");
  modal.style.display = "none";
}

// (function ($, window) {
//   $(function () {
//     let arrowWidth = 30;

//     $.fn.resizeselect = function (settings) {
//       return this.each(function () {
//         $(this)
//           .change(function () {
//             let $this = $(this);

//             // get font-weight, font-size, and font-family
//             let style = window.getComputedStyle(this);
//             let { fontWeight, fontSize, fontFamily } = style;

//             // create test element
//             let text = $this.find("option:selected").text();
//             let $test = $("<span>").html(text).css({
//               "font-size": fontSize,
//               "font-weight": fontWeight,
//               "font-family": fontFamily,
//               visibility: "hidden", // prevents FOUC
//             });

//             // add to body, get width, and get out
//             $test.appendTo($this.parent());
//             let width = $test.width();
//             $test.remove();

//             // set select width
//             $this.width(width + arrowWidth);

//             // run on start
//           })
//           .change();
//       });
//     };

//     // run by default
//     $("select.resizeselect").resizeselect();
//   });
// })(jQuery, window);
